module.exports = __webpack_public_path__ + "img/img-box-services-frontend-development-right.b0525b22.png";